export default {
  section_heading: [],
  stats: [
    {
      heading: '3,000',
      copy: 'Interactions in the first day',
    },
    {
      heading: '30,000',
      copy: 'Hashtag interactions',
    },
    {
      heading: '1 Million',
      copy: 'Video views',
    },
  ],
  component: 'm-article-stats',
}
